<template>
  <div class="nsc-radio-group">
    <VRadioGroup
      v-model="value"
      :label="label"
      :name="name"
      :disabled="!enabled"
      @change="emitChange"
    >
      <VRadio
        v-for="item in items"
        :key="item.value"
        :color="color"
        :ripple="false"
        :value="item.value"
        class="nsc-radio-option"
      >
        <template v-slot:label>
          <!-- eslint-disable vue/no-v-html -->
          <div
            class="nsc-radio-option nsc-radio-option-label"
            v-html="item.name"
          ></div>
        </template>
      </VRadio>
    </VRadioGroup>

    <div
      v-if="$slots['additional'] || $scopedSlots['additional']"
      class="nsc-additional"
      :style="{ 'margin-left': size + 'px' }"
    >
      <slot name="additional" />
    </div>
  </div>
</template>

<script>
import { VRadioGroup, VRadio } from 'vuetify/lib';

export default {
  name: 'NsRadioGroup',
  components: {
    VRadio,
    VRadioGroup,
  },
  props: {
    /**
     * color of the radio button
     */
    color: {
      type: String,
      default: '#272525',
    },

    /**
     * Indicates whether the radio button is enabled/disabled
     */
    enabled: {
      type: Boolean,
      default: true,
    },

    /**
     * label of the radio group
     */
    label: {
      type: String,
      default: '',
    },

    /**
     * Name of the component
     */
    name: {
      type: String,
      default: '',
    },

    /**
     * Value of the component to be emitted when selected.
     */
    items: {
      type: Array,
      default: () => [],
    },

    size: {
      type: Number,
      default: 24,
    },

    /**
     * Value of the model
     */
    value: {
      type: [Boolean, String, Number],
      default: null,
    },
  },
  mounted() {
    // set the default value since the mandatory option is not working
    this.value = this.$props.items[0].value;
    this.$emit('input', this.value);
  },
  methods: {
    emitChange(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use '~@nuskin/ns-core-styles/src/scss/colors';
@use "~@nuskin/ns-core-styles/src/scss/_typographyVariables.scss" as types;

.nsc-additional {
  padding-left: 0.5em;
}

.nsc-radio-option.nsc-radio-option-label {
  font-weight: 400 !important;
}
</style>
